import React, { memo } from "react";
import { getRangeColor } from "../../../../constants/rollet";

const ColorCardMobile = ({ color, onBetting, isWin, oldResult }) => {
    if (!color) return null;

    const isWinner = isWin && oldResult?.colorCode === color.code;

    const handleClick = () => {
        if (typeof onBetting === "function") {
            onBetting(color);
        }
    };

    return (
        <button
            type="button"
            onClick={handleClick}
            className={`rbm-color-card rbm-color-card--${color.code} ${
                isWinner ? "is-winner" : ""
            }`}
        >
            <div className="rbm-color-card__title">{getRangeColor?.[color.code]}</div>
            <div className="rbm-color-card__odds">{color.value}</div>
        </button>
    );
};

export default memo(ColorCardMobile);